<template>
    <tr :id="item.id" :key="item.id" :class="{'mark-as-important': item.priority == 1}">
        <td scope="row">
            <div class="form-check">
                <input class="form-check-input" type="checkbox" name="selectedOrderForDelete" v-model="selectedOrderForDelete" :value="item.id">
            </div>
        </td>
        <td>
            <router-link :to="{ name: 'orderShow', params: { id: item.id }}" class="edit-btn">#{{ item.order_number }}</router-link>
        </td>
        <td>{{ item.eta }}</td>
        <td>
            <template v-if="item.customer">
                <router-link :to="{name: 'customerDetails', params: {id: item.customer.id}}" target="_blank"
                             title="Details Customer">{{item.customer.company_name}}</router-link>
            </template>
        </td>
        <td>${{ item.total_amount }}</td>

        <td>{{ item.created_at_date }}</td>
        <td>{{ item.updated_at_date }}</td>
        <td><span :class="formatStatusClass(item)">{{ item.order_status ? item.order_status.name : "" }}</span></td>
        <td>{{ item.added_by ? item.added_by.name : '' }}</td>
        <td>
            <template v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('edit-sales-order')">
                <router-link :to="{ name: 'orderShow', params: { id: item.id }}" class="edit-btn" style="font-size:18px;"><i class="ri-edit-box-line me-1"></i></router-link>
            </template>
            <!--<span class="thumbsup"><a  href="javascript:void(0);" class="approve_btn" ><i class="ri-thumb-up-fill me-1"></i></a></span>-->
            <a  href="javascript:void(0);" v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('delete-sales-order')" v-on:click="removeItem(item.id)" class="del_btn" title="Delete Order" ><i class="ri-delete-bin-6-line"></i></a>
        </td>
    </tr>
</template>

<script>
import Vue from "vue";

export default {
    name: "OrderListItem",
    props: ['item', 'bus',],
    mounted() {
        this.bus.$on('checkOrdersForDelete', (event) => {
            this.selectedOrderForDelete = event;
        });
    },
    data(){
        return {
            selectedOrderForDelete: false
        }
    },
    methods: {
        removeItem(id){
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete order?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        this.$emit('deleteItem', {id: id});
                    }

                }
            })
        },
        formatStatusClass(item) {
            if(item.order_status) {
                return item.order_status.name.toLowerCase().replace(/\s+/g, '-').replace("/", "-").toLowerCase();
            }
            return "";
        }
    },
    watch: {
        selectedOrderForDelete: {
            handler: function(value) {
                this.$emit('changeSelectedOrderForDelete', {checked: value, id: this.item.id});
            }
        },
        item: {
            handler: function (value) {
                this.selectedOrderForDelete = false
            }
        }
    },
}
</script>

<style scoped>

</style>
